import React from 'react'
import PropTypes from 'prop-types'
import { SectionContainer, SectionTitle, Description, Select } from './styles'
import { InstallmentsSectionSkeleton } from '../Skeleton'

export const InstallmentsSection = ({
  isLoading,
  installmentOptions,
  selectedInstallment,
  onSelectInstallment,
  formattedOptions,
  formattedSelected
}) => {
  const handleChange = e => {
    const selectedId = e.target.value
    const option = installmentOptions?.find(opt => opt.id === selectedId)
    if (option && onSelectInstallment) {
      onSelectInstallment(option)
    }
  }

  if (isLoading) {
    return <InstallmentsSectionSkeleton />
  }

  return (
    <SectionContainer>
      <SectionTitle>Parcelas</SectionTitle>
      <Description>Agora, selecione em quantas parcelas você deseja parcelar o valor restante</Description>
      <Select value={selectedInstallment?.id || ''} onChange={handleChange}>
        {formattedOptions?.map(option => (
          <option key={option.id} value={option.id}>
            {option.label}
            {option.isRecommended ? ' (Recomendado)' : ''}
          </option>
        )) || <option>{formattedSelected || 'Selecione uma opção'}</option>}
      </Select>
    </SectionContainer>
  )
}

InstallmentsSection.propTypes = {
  isLoading: PropTypes.bool,
  installmentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      installments: PropTypes.number,
      installmentValue: PropTypes.number,
      totalValue: PropTypes.number,
      isRecommended: PropTypes.bool
    })
  ),
  selectedInstallment: PropTypes.object,
  onSelectInstallment: PropTypes.func,
  formattedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      isRecommended: PropTypes.bool
    })
  ),
  formattedSelected: PropTypes.string
}

InstallmentsSection.defaultProps = {
  isLoading: false,
  installmentOptions: [],
  selectedInstallment: null,
  onSelectInstallment: () => {},
  formattedOptions: [],
  formattedSelected: ''
}
